import { ProductionMaterial } from './production-item.dto';
import { GenerationParameters, ProductionDrawing } from './production-drawing.dto';

export interface HardwareGenerationParameters extends GenerationParameters {
  items?: ProductionMaterial[];
}

export interface HardwareProductionDrawing extends ProductionDrawing {
  params?: HardwareParams;
}

export interface HardwareParams {
  drawingParameters?: HardwareGenerationParameters;
}
